// Reactive safety net for stale-asset errors: a client running an old build can
// request a code-split chunk that no longer exists after a deploy. When that
// happens we reload once to pull the current assets. A one-shot guard stops an
// endless reload loop if the chunk is genuinely gone rather than just stale.

const RELOAD_GUARD_KEY = 'chunkReloaded';

const isChunkLoadError = (value) => {
  if (!value) return false;
  const message = typeof value === 'string' ? value : value.message || value.name || '';
  return (
    /Loading chunk [\w-]+ failed/i.test(message) || /Loading CSS chunk/i.test(message) || message === 'ChunkLoadError'
  );
};

const reloadOnce = () => {
  try {
    if (sessionStorage.getItem(RELOAD_GUARD_KEY)) {
      // Already reloaded once and still failing - let the error boundary handle
      // it rather than looping.
      return;
    }
    sessionStorage.setItem(RELOAD_GUARD_KEY, '1');
  } catch (e) {
    // sessionStorage may be unavailable (private mode); fall through to reload.
  }
  window.location.reload();
};

export const clearChunkReloadGuard = () => {
  if (typeof window === 'undefined') return;
  try {
    sessionStorage.removeItem(RELOAD_GUARD_KEY);
  } catch (e) {
    // ignore
  }
};

export const installChunkReloadHandler = () => {
  if (typeof window === 'undefined') return;

  window.addEventListener('error', (event) => {
    if (isChunkLoadError(event && event.error) || isChunkLoadError(event && event.message)) {
      reloadOnce();
    }
  });

  window.addEventListener('unhandledrejection', (event) => {
    if (isChunkLoadError(event && event.reason)) {
      reloadOnce();
    }
  });
};
